class ProductTabsComponent extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('[role="tablist"]');
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    this.panels = this.panels.filter((panel) => {
      if (ProductTabsComponent.hasContent(panel)) return true;
      panel.remove();
      return false;
    });

    if (!this.nav || this.panels.length === 0) {
      this.hidden = true;
      return;
    }

    this.buildTabs();
    this.tabs = [...this.nav.querySelectorAll('[role="tab"]')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e));
    });

    if (this.tabs.length > 0) {
      this.selectTab(this.tabs[0]);
    }
  }

  static hasContent(panel) {
    const content = panel.querySelector('.product-tabs__panel-content') || panel;

    if (content.textContent.trim().length > 0) return true;

    return content.querySelector('img, picture, video, iframe, svg, canvas, table, ul, ol, button, input, select, textarea') !== null;
  }

  buildTabs() {
    this.panels.forEach((panel, index) => {
      const heading = panel.dataset.tabHeading || `Tab ${index + 1}`;
      const panelId = panel.id;
      const tabId = panelId.replace('TabPanel-', 'Tab-');

      if (index > 0) {
        const separator = document.createElement('span');
        separator.className = 'product-tabs__separator';
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '|';
        this.nav.appendChild(separator);
      }

      const button = document.createElement('button');
      button.setAttribute('role', 'tab');
      button.id = tabId;
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('tabindex', index === 0 ? '0' : '-1');
      button.className = 'product-tabs__tab';
      button.textContent = heading;

      panel.setAttribute('aria-labelledby', tabId);

      this.nav.appendChild(button);
    });
  }

  selectTab(selectedTab) {
    const panelId = selectedTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.target);
    let newIndex;

    switch (event.key) {
      case 'ArrowLeft':
        newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabs.length - 1;
        break;
      case 'ArrowRight':
        newIndex = currentIndex < this.tabs.length - 1 ? currentIndex + 1 : 0;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.tabs[newIndex].focus();
    this.selectTab(this.tabs[newIndex]);
  }
}

if (!customElements.get('product-tabs-component')) {
  customElements.define('product-tabs-component', ProductTabsComponent);
}
